import type { PublicMapSettingsResponse } from '~/map/map.repository';
import { MapKeyType } from '~/sidebar/sidebarApps/rightSidebar/masterKey/masterKey.types';
import { publicMapSettingsInitialState } from './mapSettingsPublicMapSettings.reducer';
import type { MapSettingsPublicMapSettingsState } from './mapSettingsPublicMapSettings.state';

export const mapSettingsPublicMapSettingsSerializer = {
  jsonToState: (json: PublicMapSettingsResponse): MapSettingsPublicMapSettingsState => {
    const { locationList, locationListOpen, ...jsonRest } = json;

    return ({
      ...publicMapSettingsInitialState,
      ...jsonRest,
      ...(locationList ? {
        mapKey: true,
        defaultOpenMapKey: MapKeyType.LocationList,
      } : {}),
      ...(locationListOpen ? { mapKeyOpen: true } : {}),
    });
  },
  stateToJson: (state: MapSettingsPublicMapSettingsState): PublicMapSettingsResponse => {
    return state;
  },
};
